import axios from 'axios';

// Endpoints
const SOLARWINDS_ENDPOINT = 'solarwinds/volumes';

const SET_SOLARWINDS_VOLUMES = 'solarwinds/SET_SOLARWINDS_VOLUMES';

// initial state
const state = {
  solarWindsVolumes: {},
};

// actions
const actions = {
  GET_SOLARWINDS_VOLUMES: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(SOLARWINDS_ENDPOINT)
        .then(response => {
          commit(SET_SOLARWINDS_VOLUMES, response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    })
  },
};

const getters = {
  getSolarWindsVolumes: state => state.solarWindsVolumes,
};

const mutations = {
  [SET_SOLARWINDS_VOLUMES](state, data) {
    state.solarWindsVolumes = data;
  },
};

export default {
  state: { ...state },
  actions,
  getters,
  mutations
};
